import React, { Component } from 'react';
import { Form,Button, InputGroup } from 'react-bootstrap';

export class TableFilter extends Component {

    constructor(props) {
        super(props);
        this.onFilter = this.onFilter.bind(this);
        this.onFilterClear = this.onFilterClear.bind(this);
        this.state = {
            filterText: this.props.filterText
        };
    }     

    onFilter(e) {        
        var searchText = e.target.value;       
        this.setState({
            filterText: searchText
        });
        this.props.onFilter(searchText);

    }
    onFilterClear() {
        this.setState({
            filterText: ''
        });
        this.props.onFilterClear();
    }
    render() {
        const { filterText } = this.state;
        var labelTxt = (this.props.label) ? this.props.label : "Search for address";
    return (     
        <>
            <InputGroup md={2} className="addressFilter">
            <Form.Control
                    placeholder={labelTxt}
                    aria-label={labelTxt}
                value={filterText}
                onChange={this.onFilter}
                key="addressfilter1"
                autoFocus
            />
            <Button variant="primary" id="button-addon2" onClick={this.onFilterClear}> X </Button>
            </InputGroup>
            </>
        );
    }
}

